const topics = [
  { label: '暑期档热映', hot: true },
  { label: '国产剧王', hot: true },
  { label: '韩剧精选', hot: false },
  { label: '豆瓣高分', hot: true },
  { label: '悬疑烧脑', hot: false },
  { label: '古装巨制', hot: false },
  { label: '动漫番剧', hot: true },
  { label: '纪录片', hot: false },
  { label: '院线大片', hot: true },
  { label: '经典重温', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10 max-w-xl mx-auto">
          大家都在追的话题，找到属于你的观影圈子
        </p>
        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              {topic.label}
              {topic.hot && (
                <span className="text-[10px] md:text-xs text-accent-500 font-semibold">HOT</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}